import { POST } from "../../index";

export const carCountContrast = (param) => POST("/v1/customizeHomePage/carCountContrast", param);
export const getMaintenance = (param) => POST("/v1/customizeHomePage/getMaintenance", param);
export const getStatisticalData = (param) => POST("/v1/customizeHomePage/getStatisticalData", param);
export const getCountryCarCount = (param) => POST("/v1/customizeHomePage/getCountryCarCount", param);
export const getDayViolationAndMalfunction = (param) => POST("/v1/customizeHomePage/getDayViolationAndMalfunction", param);

